import { BaseState } from '@/store/base-state';
import { TableOptions } from '@/types';
import { PurchaseOrders } from '@/modules/purchase-orders/types';

export default class FilesState extends BaseState {
  files: PurchaseOrders.File[] = [];
  file: File | null | any = null;

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: [''],
    sortDesc: [true],
  };

  loading = false;
}
